import React from "react";
import { connect } from "react-redux";
import language from "../../../language/index.js";
import { getStorage } from "../../../utils/storage.js";
import {
  fetchShippingInQueueData,
  deleteQueue,
} from "../../../utils/queries/request/shipping-queue.js";
import toastMessage from "../../../utils/toastMessage.js";
import List from "./List.js";
import CardHeader from "../../Header/CardHeader.js";
import {
  deleteReturnRequest,
  fetchReturnRequest,
} from "../../../utils/queries/return-request.js";
import {
// eslint-disable-next-line no-unused-vars
  fetchReturnedProducts,
} from "../../../utils/queries/return-product.js";

// eslint-disable-next-line no-unused-vars
let copyData = [];
// eslint-disable-next-line no-unused-vars

class ShippingQueue extends React.Component {
  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 1000000,
    search_text: "",
    selectedData: {},
    delete_value: "",
    error: {},
    csvData: [],
    user: {},
    shipmentNumber: "",
    returnInfo: null,
  };

  componentDidMount = async () => {
    const user = await getStorage();

    this.setState({ user });

    await this.fetchData(true);

    this._pollInterval = setInterval(() => this.fetchData(false), 10000);
  };

  componentWillUnmount() {
    clearInterval(this._pollInterval);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isRefreshing !== this.props.isRefreshing) {
      this.fetchData(true);
    }

    if (prevProps.refreshShipmentNumber !== this.props.refreshShipmentNumber) {
      this.fetchData(true);
    }

    if (prevProps.shipmentNumber !== this.props.shipmentNumber) {
      this.setState({ data: [], returnInfo: null }, () => this.fetchData(true));
    }
  }

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e && e?.target ? e?.target?.value : e,
      error,
    });
  }

  fetchData(isLoading) {
    if (this.props.isReturn) {
      return this.getReturnRequest(isLoading);
    }

    this.getFromShipping(isLoading);
  }

  getFromShipping = async (isLoading) => {
    try {
      const { page, limit } = this.state;
      const {
        defaultLanguage,
        shipmentNumber,
        donationNumber,
        status,
        addedBy,
        requestNo,
      } = this.props;

      // For nominative requests, query by requestNo to show all products ever
      // added for this request across all shipment numbers (including transferred).
      // Fall back to shipmentNumber for non-nominative contexts.
      const hasFilter = (requestNo && requestNo !== "") || (shipmentNumber && shipmentNumber !== "");
      if (!hasFilter) return;

      this.setState({ isLoading });

      const requestBody = {
        page,
        limit,
        addedBy,
        ...(requestNo ? { requestNo } : { shipmentNumber }),
        status,
        donationNumber,
      };

      const { data, count, totalRecords } = await fetchShippingInQueueData(
        defaultLanguage,
        requestBody
      );

      this.setState({
        data: data,
        totalPageCount: count,
        totalRecords,
        isLoading: false,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({
        isLoading: false,
      });

      toastMessage("error", error);
    }
  };

  getReturnRequest = async (isLoading) => {
    try {
      const { page, limit } = this.state;
      const {
        defaultLanguage,
        shipmentNumber,
        donationNumber,
        status,
        addedBy,
      } = this.props;

      if (!shipmentNumber || shipmentNumber === "") {
        return;
      }

      this.setState({ isLoading });

      const returnRes = await fetchReturnRequest(defaultLanguage, {
        returnNumber: shipmentNumber,
      });
      // fetchReturnRequest without page/limit returns queryRes.data directly,
      // which is { data: [...], count, totalRecords } — not a plain array.
      const returnInfoArray = Array.isArray(returnRes)
        ? returnRes
        : (returnRes?.data || []);

      if (returnInfoArray.length === 0) {
        this.setState({ isLoading: false });
        return;
      }

      const requestBody = {
        page,
        limit,
        addedBy,
        returnId: returnInfoArray[0]._id,
        status,
        donationNumber,
      };

      const { data, count, totalRecords } = await fetchReturnedProducts(
        defaultLanguage,
        requestBody
      );

      this.setState({
        data: data,
        returnInfo: returnInfoArray[0],
        totalPageCount: count,
        totalRecords,
        isLoading: false,
      });

      copyData = data.slice(0);
    } catch (error) {
      console.log(error);
      this.setState({
        isLoading: false,
      });

      toastMessage("error", error);
    }
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.fetchData(true);
      }
    );
  }

  handleShowModal(modal, modalTitle, selectedData = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selectedData,
      reason: selectedData.reason || "",
    });

    if (selectedData?.donation) {
      this.setState({ donation: selectedData.donation });
    }
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      if (this.props.isReturn) {
        await deleteReturnRequest(
          this.props.defaultLanguage,
          this.state.selectedData._id
        );
      } else {
        await deleteQueue(
          this.props.defaultLanguage,
          this.state.selectedData._id
        );
      }

      this.setState({ isDeleting: false });

      this.fetchData(true);
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      this.setState({
        isDeleting: false,
      });
    }
  };

  render() {
    if (this.state.data.length === 0) return;

    return (
      <>
        <CardHeader title={language[this.props.defaultLanguage].shipments} />
        <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
          <div className="card-body">
            <List
              data={this.state.data}
              page={this.state.page}
              limit={this.state.limit}
              search_text={this.state.search_text}
              showAdd
              addButtonText={language[this.props.defaultLanguage].create}
              handleAddPressed={() => this.handleShowModal("showPrint")}
              handleClose={this.props.handleCloseModal}
              totalPageCount={this.state.totalPageCount}
              totalRecords={this.state.totalRecords}
              isLoading={this.state.isSearching}
              getData={this.fetchData.bind(this, true)}
              getReturnRequest={this.getReturnRequest.bind(this, true)}
              onTransferred={this.props.onReturnTransferred}
              selectedData={
                this.props.isReturn
                  ? this.state.returnInfo || {}
                  : this.state.data?.length > 0
                  ? this.state.data[0]
                  : {}
              }
              addedBy={this.props.addedBy}
              requestNo={this.props.requestNo}
              category={this.props.category}
              isReturn={this.props.isReturn}
              isForNominative={this.props.isForNominative}
            />
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { refreshShipmentNumber } = state.ShipmentNumber;
  return {
    defaultLanguage,
    refreshShipmentNumber,
  };
};

export default connect(mapStateToProps)(ShippingQueue);
